<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.create')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-form @submit.prevent="onSubmit" class="av-tooltip">
            <b-form-group :label="$t('anyform.selectImageEn')">
              <b-form-file v-model="createForm.image_en" accept="image/*"></b-form-file>
            </b-form-group>

            <b-form-group :label="$t('anyform.selectImageRu')">
              <b-form-file v-model="createForm.image_ru" accept="image/*"></b-form-file>
            </b-form-group>

            <b-form-group :label="$t('pages.sliders.link')">
              <b-form-input type="text" v-model="$v.createForm.link.$model" :state="!$v.createForm.link.$error" />
              <b-form-invalid-feedback v-if="!$v.createForm.link.required">
                {{ $t('formErrors.enterLink') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="$t('pages.faq.sort')">
              <b-form-input
                type="text"
                v-model="$v.createForm.sort.$model"
                :state="!$v.createForm.sort.$error"
                min="0"
              />
              <b-form-invalid-feedback v-if="!$v.createForm.sort.required">
                {{ $t('formErrors.enterSort') }}
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!$v.createForm.sort.numeric">
                {{ $t('formErrors.mustBeNumber') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-button
              type="submit"
              variant="primary"
              :disabled="isLoading"
              :class="{
                'btn-multiple-state mt-2': true,
                'show-spinner': isLoading
              }"
            >
              <span class="spinner d-inline-block">
                <span class="bounce1"></span>
                <span class="bounce2"></span>
                <span class="bounce3"></span>
              </span>
              <span class="label">
                {{ $t('buttons.save') }}
              </span>
            </b-button>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
const { required, numeric } = require('vuelidate/lib/validators')

export default {
  data: () => ({
    isLoading: false,
    createForm: {
      link: '',
      sort: null,
      image_en: null,
      image_ru: null
    }
  }),
  validations: {
    createForm: {
      link: { required },
      sort: { required, numeric }
    }
  },
  methods: {
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('sliders/createSingleSlider', {
          payload: this.createForm,
          vm: this
        })
      }
    }
  }
}
</script>
